import React, { memo } from 'react'

import { useFetchData } from "../../../Hooks/Main/useFetchData"

import ModalComponent from '../../../Components/ModalComponent'

import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from "yup"
import ReligionTable from './ReligionTable'
import useShowModalContext from '../../../Hooks/ContextHooks/General/useShowModalContext'
import ReligionModalForm from './ReligionModalForm'

const validationSchema = yup.object().shape({
    fullName: yup.string().required("Please enter your full name"),
    gender: yup.string().required("Please select your gender"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Please enter your email address"),
    phone: yup
      .string()
      .matches(
        /^[0-9]+$/,
        "Please enter a valid phone number with digits only"
      )
      .required("Please enter your phone number"),
    description: yup.string("Should be text"),
    // items: yup
    //   .array()
    //   .of(
    //     yup.object({
    //       id: yup.number().required(),
    //       name: yup.string().required(),
    //       price: yup.number().required(),
    //       quantity: yup
    //         .number()
    //         .min(1, "Quantity must be at least 1")
    //         .required(),
    //     })
    //   )
    //   .min(1, "Please select at least one item"),
})
const items = [
  { id: 1, for: "ختم قرآن", type:"Urgent Aid", count:3, usdAmount:200, afAmount:168000, owner:"-"},
  { id: 2, for: "خمس", type:"Urgent Aid", count:2, usdAmount:30, afAmount:3000, owner:"-"},
  { id: 3, for: "زکات", type:"Urgent Aid", count:1, usdAmount:20, afAmount:200, owner:"-"},
  { id: 4, for: "فطریه", type:"Urgent Aid", count:4, usdAmount:50, afAmount:8700, owner:"-"},
];



function ReligionTax() {

  const { data } = useFetchData("getGender")

  const {setShowModal} = useShowModalContext()
  
  return (
    <div className="container">
      <Formik
        initialValues={{
          fullName: "",
          gender: "",
          email: "",
          phone: "",
          description: "",
          items: items.map((item) => ({ ...item, quantity: 0 })),
        }}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          alert(JSON.stringify(values));
          actions.resetForm();
        }}
      >
        {(props) => (
          <Form>
            <div className='container'>
              <div className="row mt-4">
                <div className="col-md-4 my-2">
                  <div className='bg-light px-5 pt-4 pb-5 rounded'>
                    <h4 className='text-center mb-5 mt-4'>Payer Information</h4>
                    <div className='mb-3'>
                      <Field
                        name="fullName"
                        type="text"
                        className="form-control"
                        placeholder="Enter your full name"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="fullName" />
                      </span>
                    </div>
                    <div className="mb-3">
                      <Field
                        as="select"
                        name="gender"
                        type="text"
                        className="form-select"
                        placeholder="Select your gender"
                      >
                        <option value="">Select gender</option>
                        {data && data.map((gender, i) => {
                          return <option value={gender.code} key={i}>{gender.name}</option>
                        })}
                      </Field>
                      <span className="text-danger">
                        <ErrorMessage name="gender" />
                      </span>
                    </div>
                    <div className="mb-3">
                      <Field
                        name="email"
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="email" />
                      </span>
                    </div>
                    <div className="mb-3">
                      <Field
                        name="phone"
                        type="text"
                        className="form-control"
                        placeholder="Enter your phone number"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="phone" />
                      </span>
                    </div>
                    <div className="mb-3">
                      <Field
                        name="description"
                        type="text"
                        className="form-control"
                        placeholder="Enter a description"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="description" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className='col-md-8 my-2'>
                  <ReligionTable />
                  <div className='mt-5 text-center'>
                    <button type="button" className='btn btn-sm web-btn' onClick={()=>setShowModal(true)}>Choose Religion Tax</button>
                  </div>
                  <div className='mt-5 text-center'>
                    <button type="button" className='btn btn-sm btn-primary px-5'>
                      <span>Pay Tax</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <ModalComponent size="lg" title="Add religion tax">
              <ReligionModalForm />
            </ModalComponent>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default memo(ReligionTax)
